import {css} from '@emotion/react'

import ButtonLink from '../../components/Button/ButtonLink'
import {AnimatedContent, TwoColumnContent} from '../../components/content'
import {BREAKPOINT_LARGE, BREAKPOINT_SMALL, BREAKPOINT_XLARGE} from '../../styles/breakpoints'
import {
  backgroundGradientCss,
  centeredTextCss,
  baseSectionCss,
  h3SubheadlineCss,
  hBoldCss,
  whiteTextCss,
  h4Body1Css,
} from '../../styles/common'

const alignCss = css`
  align-items: center;

  @media (max-width: ${BREAKPOINT_LARGE}px) {
    align-items: stretch;
  }
`

const leftTextCss = css`
  margin: 45px 0px;

  @media (max-width: ${BREAKPOINT_LARGE}px) {
    margin-bottom: 65px;
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin-top: 35px;
  }
`

const rightCss = css`
  padding-left: 120px;
`

const freeTriaButtonCss = css`
  height: 65px;
  width: 550px;
  border: 1px solid #fff;

  @media (max-width: ${BREAKPOINT_XLARGE}px) {
    width: 439px;
  }

  @media (max-width: ${BREAKPOINT_LARGE}px) {
    width: 100%;
  }
`

export default function WERSection(): JSX.Element {
  return (
    <section css={[baseSectionCss, backgroundGradientCss]}>
      <TwoColumnContent
        css={alignCss}
        left={
          <>
            <AnimatedContent>
              <h3 css={[h3SubheadlineCss, hBoldCss, whiteTextCss, centeredTextCss]}>
                What is Word Error Rate (WER)?
              </h3>
            </AnimatedContent>
            <AnimatedContent>
              <p css={[leftTextCss, h3SubheadlineCss, whiteTextCss, centeredTextCss]}>
                Check out our free WER calculator to see how accurate your speech recognition is.
              </p>
            </AnimatedContent>
          </>
        }
        rightContentCss={rightCss}
        right={
          <AnimatedContent animation="fade-in">
            <ButtonLink
              to="/scribe/wer-calculator"
              variant="secondary"
              mode="dark"
              css={[freeTriaButtonCss, whiteTextCss, h4Body1Css]}
            >
              WER Calculator
            </ButtonLink>
          </AnimatedContent>
        }
      />
    </section>
  )
}
